import * as React from 'react';
import { getDefaultCustomer } from '../../../Services/UserService';
import Item from './Item';

interface IComponentProps {
  activePaging?: any;
  activeRows?: any;
  activeSorting?: any;
  key?: string;
  label?: boolean;
  action?: any;
  save?: any;
  filterComponent?: any;
  columns?: any;
  stateValue: any;
  parentState: any;
  actionOpen: any;
  setValue: any;
  handleChange?: any;
  actionSave: any;
  reset: any;
  name?: string;
  data: any;
  clearFilter: any;
  setFilter?: any;
  openedMenuName: any;
  tableName: string;
}

function TableFilters(props: IComponentProps) {
  const {
    data,
    setFilter,
    tableName,
    clearFilter,
    stateValue,
    parentState,
    setValue,
    actionOpen,
    handleChange,
    actionSave,
    reset,
    openedMenuName,
  } = props;
  const { columns, paging, sorting } = data;

  const checkCondition = (column): boolean => {
    if (
      typeof column.filter === 'object' &&
      column.filter !== null &&
      column.filter.active === true
    ) {
      if (column.name === 'customerId' && getDefaultCustomer().length === 1) {
        return false;
      }
      return true;
    }

    return false;
  };

  return (
    <div className="my-2">
      {Object.keys(columns)
        .filter((i: any) => checkCondition(columns[i]))
        .map((j) => (
          <Item
            activePaging={paging}
            activeRows={columns}
            activeSorting={sorting}
            key={`filter-item-${columns[j].name}`}
            label={true}
            clearFilter={clearFilter}
            save={setFilter}
            filterComponent={columns[j].filter}
            columns={columns[j]}
            stateValue={stateValue}
            parentState={parentState}
            actionOpen={actionOpen}
            setValue={setValue}
            handleChange={handleChange}
            actionSave={actionSave}
            reset={reset}
            // name={name}
            openedMenuName={openedMenuName}
            tableName={tableName}
          />
        ))}
    </div>
  );
}

export default TableFilters;
